export default __webpack_public_path__ + "static/media/snow.9c87d24e.svg";